module.exports = __webpack_public_path__ + "img/upload-video-icon.e68c3ecd.png";